module.exports = __webpack_public_path__ + "static/media/12.ab3726d6.jpg";